import React from "react";
import { useTranslation } from "react-i18next";
import AgreementPdfViewer from "../../../components/agreement/agreementPdfViewer";
import SignaturePad from "../../../components/agreement/signaturePad";

interface FinalReviewStepProps {
  pdfUrl?: string | null;
  signature: string | null;
  onSignatureChange: (dataUrl: string | null) => void;
  showPdf?: boolean;
}

const FinalReviewStep: React.FC<FinalReviewStepProps> = ({
  pdfUrl,
  signature,
  onSignatureChange,
  showPdf = true,
}) => {
  const { t } = useTranslation("dealModal");

  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-[#71717A]">{t("agreementTerms")}</p>

      {!showPdf && (
        <p className="text-sm text-[#71717A]">{t("editAgreementNote")}</p>
      )}
      {showPdf && (
        <AgreementPdfViewer
          pdfUrl={pdfUrl}
          title={t("contractPdf")}
          emptyMessage={t("contractNotAvailable")}
        />
      )}

      <SignaturePad
        signature={signature}
        onSignatureChange={onSignatureChange}
      />
    </div>
  );
};

export default FinalReviewStep;